import type { NavigateFunction } from 'react-router-dom';
import { deleteConferenceProfile } from '../conferenceProfiles/api';

/**
 * Shared helpers for Conference Profiles module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Conference Profile in the form.
 * Pattern: /settings/pbx/conference-profiles/new?duplicate={id}
 */
export const getConferenceProfileDuplicateUrl = (id: string | number): string =>
  `/settings/pbx/conference-profiles/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Conference Profile id.
 */
export const navigateToConferenceProfileDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getConferenceProfileDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Conference Profile by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteConferenceProfile from '../conferenceProfiles/api' instead
 */
export const deleteConferenceProfileById = async (
  id: string | number,
  tenantSlug?: string,
  userId?: string | number | null
): Promise<void> => {
  // Delegate to the new API function
  await deleteConferenceProfile(id);
};

